/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Autocomplete, AutocompleteProps, AutocompleteRenderGroupParams, ListSubheader } from '@mui/material';
import { UseAutocompleteProps } from '@mui/material/useAutocomplete';

import { createHUAutocompleteStyles } from './HUAutocomplete.styles';

export type HUAutocompleteProps<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
> = AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> &
  UseAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>;

export function HUAutocomplete<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>(props: HUAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
  const classes = createHUAutocompleteStyles();

  const renderGroup = (params: AutocompleteRenderGroupParams) => (
    <li key={params.key}>
      <ListSubheader className={classes.groupLabel} component="div">
        {params.key}
      </ListSubheader>
      <ul className={classes.groupUl}>{params.children}</ul>
    </li>
  );

  return <Autocomplete renderGroup={renderGroup} {...props} classes={classes} />;
}
